import React, { ChangeEvent, ReactNode } from "react";
import classes from "./TreePropsInput.module.css";
interface TreePropsInputProps {
    className?: string;
    placeholder?: string;
    children?: ReactNode;
    search: string;
    setSearch: React.Dispatch<React.SetStateAction<string>>;
}
function TreePropsInput({
    className,
    placeholder = "Search...",
    children,
    search,
    setSearch,
    ...props
}: TreePropsInputProps) {
    return (
        <input
            type="text"
            placeholder={placeholder}
            value={search}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setSearch(e.target.value || "");
            }}
            className={[className, classes.input].join(" ")}
            {...props}
        >
            {children}
        </input>
    );
}

export default TreePropsInput;
